import React from 'react';
import { Switch } from 'react-router';
import { Config } from '@leverege/plugin';
import { Content, ToggleButton } from '@leverege/ui-elements';
import { TitleBar, Toolbar, createConnect, StringShortener } from '@leverege/ui-plugin';
import { Attributes } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import { History } from '@leverege/molten-core';
import { UI } from '@leverege/ui-redux';
import { ValuesCache } from '@leverege/value-cache';
import Blocker from "../../views/blocker/Blocker.js";
import { Routes } from "../../routes/index.js";
import S from './DesktopItemScreen.css';
import { getQueryTrigger } from "../utils/QueryTriggers.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.item.DesktopItemScreen');
class DesktopItemScreen extends React.Component {
  static CLIENT = 'ItemScreen';
  constructor(props) {
    super(props);
    const path = props?.relationship?.path;
    this.trigger = getQueryTrigger({
      loadData: this.loadData,
      objectType: props.relationship?.objectType,
      path: props.relationship?.path,
      client: DesktopItemScreen.CLIENT,
      relationship: props.relationship,
      caches: new ValuesCache()
    }, this.getContext());
  }
  getContext() {
    return {
      client: DesktopItemScreen.CLIENT,
      clientProps: this.props,
      reloadData: this.loadData
    };
  }
  componentDidMount() {
    this.unmounted = false;
    this.trigger.init?.();
    const {
      dispatch
    } = this.props;
    const collapsed = localStorage.getItem('collapsed');
    dispatch(UI.set('collapsed', collapsed ? JSON.parse(collapsed) : {}));
  }
  componentDidUpdate(prevProps) {
    const {
      resourceId: pResourceId,
      collapsed: prevCollapsed
    } = prevProps;
    const {
      resourceId,
      collapsed
    } = this.props;
    if (resourceId != null && pResourceId !== resourceId) {
      this.loadData();
    }
    if (collapsed !== prevCollapsed) {
      localStorage.setItem('collapsed', JSON.stringify(collapsed));
    }
  }
  componentWillUnmount() {
    this.trigger.cleanup?.();
    this.unmounted = true;
  }
  loadData = async opts => {
    await this.trigger.preQuery?.();
    const {
      delegate,
      dispatch
    } = this.props;
    try {
      await dispatch(delegate.get(opts));
      if (this.unmounted !== true && (!this.isInError || opts?.force)) {
        await this.trigger.postQuery?.();
      }
    } catch (err) {
      console.error(err);
      // eslint-disable-next-line no-console
      if (this.unmounted !== true && (!this.isInError || opts?.force)) {
        await this.trigger.postQuery?.(err);
      }
      this.isInError = true;
    }
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  onBack = e => {
    const {
      dispatch,
      delegate
    } = this.props;
    dispatch(delegate.parent().goTo());
  };
  render() {
    const {
      relationship,
      delegate,
      dispatch,
      item
    } = this.props;
    const {
      path,
      objectType
    } = relationship;
    const matchContext = {
      client: DesktopItemScreen.CLIENT,
      objectType,
      path,
      relationship,
      mobile: false
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      hooks: [{
        execute() {
          return item == null && dispatch(delegate.get());
        }
      }],
      context: this.props,
      render: this.renderChildren
    });
  }
  onCollapse = ({
    value
  }) => {
    const {
      dispatch,
      collapsed
    } = this.props;
    const path = this.props?.relationship?.path;
    if (path) {
      dispatch(UI.set('collapsed', {
        ...collapsed,
        [path]: value
      }));
    }
  };
  renderChildren = () => {
    const client = DesktopItemScreen.CLIENT;
    const {
      nameAttr = 'name',
      iconAttr = 'icon',
      item,
      delegate,
      embed,
      relationship: {
        blueprint,
        path,
        objectType
      },
      relationship
    } = this.props;
    let {
      collapsed
    } = this.props;
    collapsed = collapsed[path];
    const matchContext = {
      use: 'navBar',
      client,
      objectType,
      path,
      embed
    };
    const routeMatch = {
      client,
      objectType,
      path
    };
    const routeKey = `item:${client}:${objectType}:${path}`;
    const name = Attributes.get(nameAttr, objectType, item) || blueprint.name;
    const icon = Attributes.get(iconAttr, objectType, item);
    const ref = delegate.getInterfaceUrl();
    const showNavBar = Config.get(`blueprint.${path}.${client}`, 'showNavBar', true);
    let header;
    if (!showNavBar) {
      header = null;
    } else if (embed) {
      let hideToolbar = false;
      if (relationship.url != null) {
        const extraArray = window.location.pathname.substring(History.adjustPath(relationship.url).length + 1).split('/');
        hideToolbar = extraArray.length > 1;
      }
      if (!hideToolbar) {
        header = /*#__PURE__*/_jsx(Content.Header, {
          variant: "embededScreenHeader|rootEditorHeader",
          children: /*#__PURE__*/_jsx(Toolbar, {
            variant: "navBar",
            prefer: "text",
            matchContext: matchContext,
            context: this.getContext()
          })
        });
      }
    } else {
      const collapsable = Config.get(client, 'collapsable', true);
      collapsed = collapsed && collapsable;
      const ttv = collapsed ? 'sideNavSmall|sideNav' : 'sideNav';
      const tbv = collapsed ? 'sideNavBarSmall|sideNavBar' : 'sideNavBar';
      const pref = collapsed ? 'icon' : 'both';
      const hide = collapsed && collapsable;
      const cv = collapsed ? 'sideNavBarCollapseSmall|sideNavBarCollapse|sideNavBarSmall|sideNavBar' : 'sideNavBarCollapse|sideNavBar';
      const title = collapsed ? StringShortener.shorten(name, 2) : name;
      header = /*#__PURE__*/_jsx(Content.Header, {
        variant: "rootEditorHeader",
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: ttv,
          title: title,
          icon: icon,
          children: /*#__PURE__*/_jsxs(Content, {
            relative: true,
            className: collapsed ? S.navBarSmall : S.navBar,
            children: [/*#__PURE__*/_jsx(Content.Area, {
              children: /*#__PURE__*/_jsx(Toolbar, {
                variant: tbv,
                hideWhenIconOnly: hide,
                prefer: pref,
                vertical: true,
                matchContext: matchContext,
                context: this.getContext()
              })
            }), collapsable && /*#__PURE__*/_jsx(Content.Header, {
              variant: "sideNavBarCollapse",
              layout: "flex:sideNavBarCollapse",
              children: /*#__PURE__*/_jsx(ToggleButton, {
                variant: cv,
                onChange: this.onCollapse,
                value: collapsed,
                iconOn: Config.get(client, 'collapseOpenIcon', 'fa fa-chevron-right'),
                iconOff: Config.get(client, 'collapseCloseIcon', 'fa fa-chevron-left'),
                children: collapsed ? null : Config.get(client, 'collapseLabel', t('collapse'))
              })
            })]
          })
        })
      });
    }
    return /*#__PURE__*/_jsxs(Content, {
      variant: "rootEditor",
      horizontal: !embed,
      children: [header, /*#__PURE__*/_jsx(Content.Area, {
        variant: "rootEditorContent",
        children: /*#__PURE__*/_jsx(Switch, {
          children: Routes.getRoutesFor(routeKey, null, routeMatch, {
            parentItem: {
              type: objectType,
              data: item,
              ref,
              id: delegate.id
            },
            reloadData: this.loadData
          }, Config.get(client, 'redirectUrl'))
        })
      })]
    });
  };
}
const connect = createConnect(DesktopItemScreen.CLIENT, (s, props) => {
  return {
    client: DesktopItemScreen.CLIENT,
    objectType: props.relationship?.objectType,
    path: props.relationship?.path
  };
});
export default connect((state, props) => {
  const {
    delegate
  } = props;
  return {
    collapsed: state?.ui?.collapsed,
    item: delegate.getItem(state, true) // skip the parent check
  };
})(DesktopItemScreen);